import axios from "axios";

import {
  Chunk,
  DriveItem,
  UploadBytesResponse,
  UploadSessionResponse,
} from "../../models";
import axiosClient from "../axiosBase";
import { FileServices } from "./FileServices";

const MAX_SMALL_FILE_SIZE = 4194304; // 4 MiB

export class MsGraphFile extends FileServices {
  constructor(public file: File, public url: string) {
    super(file);
  }

  private createUploadSession() {
    return axiosClient.post<UploadSessionResponse>(this.url, {
      "@microsoft.graph.conflictBehavior": "replace",
      name: this.file.name,
    });
  }

  private async uploadChunks(
    chunkList: Array<Chunk>,
    uploadUrl: string,
    retryCount: number = 3
  ): Promise<any> {
    try {
      const missByteRangesRes = await axios.get<UploadBytesResponse>(uploadUrl);
      const sByte = parseInt(
        missByteRangesRes.data.nextExpectedRanges[0].split("-")[0]
      );
      for (const { chunk, startByte, endByte } of chunkList) {
        if (startByte >= sByte) {
          const headers = {
            "Content-Range": `bytes ${startByte}-${endByte - 1}/${
              this.file.size
            }`,
          };
          const response = await axios.put<DriveItem>(uploadUrl, chunk, {
            headers,
          });
          if (response.status === 201) return response;
        }
      }
    } catch (error) {
      if (retryCount === 0) return Promise.reject("Upload error");
      return this.uploadChunks(chunkList, uploadUrl, retryCount - 1);
    }
  }

  private normalUpload() {
    return axiosClient.put<DriveItem>(this.url, this.file);
  }
  private async resumableUpload() {
    const uploadSessionRes = await this.createUploadSession();
    const chunks = this.chunk();
    return this.uploadChunks(chunks, uploadSessionRes.data.uploadUrl);
  }

  upload() {
    if (this.file.size < MAX_SMALL_FILE_SIZE) {
      return this.normalUpload();
    }
    return this.resumableUpload();
  }
}
